<template>
  <div class="visitor-contacts-checkbox">
    <div class="text-medium">
      {{ $t('qlm_same_contacts') }}
    </div>
    <slot name="toggle"></slot>
  </div>
</template>

<style lang="scss" scoped>
  .visitor-contacts-checkbox {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: var(--spacing-3);
    padding-block: var(--spacing-2);
  }
</style>
